import React from "react";
import Marty from "marty";
import Hero from "../components/Hero";
import SuspectCarousel from "./components/SuspectCarousel";
import ImageSlideshow from "../../../components/ImageSlideshow";
import HouseSelect from "./components/HouseSelect";
import BuyButton from "../../../components/BuyButton";

const suspectData = [
    {
        text: "Materials like brick, stone, concrete, metal, and glass all cause problems. Plus, because of their shape, 5GHz waves don’t go through walls and furniture as well as 2.4GHz waves.",
        icon: "eo-icon-wall",
        title: "Walls and furniture"
    },
    {
        text: "WiFi waves are just radio waves, so as you get farther from the access point, their strength diminishes. In general, the higher the frequency of radio wave — the newer 5GHz band, for example — the better the performance, but the shorter the range.",
        icon: "eo-icon-distance",
        title: "Distance"
    },
    {
        text: "Depending on the density of your neighborhood, you could have 50 or more WiFi networks nearby, all competing with yours for limited available radio spectrum. The 5GHz spectrum is much less crowded than 2.4GHz.",
        icon: "eo-icon-neighbor2",
        title: "Neighbors"
    },
    {
        text: "Believe it or not, household appliances like refrigerators, water heaters and remotes can interfere with your WiFi signal. The more stuff you have, the worse it can be.",
        icon: "eo-icon-tv",
        title: "Appliances"
    }
];

const slideUrls = [
    "hero-kitchen.jpg",
    "hero-woodshop.jpg",
    "hero-bedroom.jpg",
    "hero-livingroom.jpg",
].map(file => `/public/img/in-the-home/heros/${file}`);

let InTheHome = React.createClass({
    mailingList() {
        this.app.navStore.showMailingListModal();
    },
    componentWillMount() {
        if (Marty.isBrowser) {
            document.title = "eero - In your home";
        }
    },
    render() {
        return (
            <section className="eo-view in-the-home grid-10 parent">
                <Hero>
                    <ImageSlideshow urls={slideUrls} interval={5000}/>
                    <div className="eo-hero-overlay"></div>
                    <div className="eo-hero-main-content">
                        <div className="eo-info-panel">
                            <h1>Wall-to-wall WiFi</h1>
                        </div>
                    </div>
                </Hero>

                <div className="eo-padded-wrapper">
                    <section className="eo-section grid-10 eo-info-panel suspects eo-centered">
                        <div className="grid-4 grid-s-10 parent suspects-copy">
                            <h2 className="">The usual<br/>(dead zone)<br/>suspects</h2>
                            <p className="eo-info-panel-copy">Homes are almost as diverse and unique as the people inside of them. Size, shape, materials, and proximity to neighbors’ networks all
                                impact WiFi strength and reliability.</p>
                        </div>
                        <SuspectCarousel className="grid-6 grid-s-10 parent" data={suspectData}/>
                    </section>
                    <section className="grid-10 eo-section home parent eo-centered">
                        <div className="eo-info-panel grid-10 parent dark mobile-heading">
                            <h2 className="eo-info-panel-header">How many eeros does your home need?</h2>

                            <p className="menu-copy">A set of three will cover the average home (2,000 - 4,000 sq. ft.). But the beauty of eero is that with TrueMesh you can expand your system to cover any home,
                                regardless of its size or shape. Here are a few examples to help you figure out what’s right for your place.</p>
                        </div>
                        <HouseSelect/>
                    </section>
                </div>
                <section className="grid-10 eo-cta hottest-spot hide-s">
                    <div className="eo-cta-content float-left">
                        <h2 className="eo-cta-header">MAKE YOUR HOME<br/>THE HOTTEST SPOT</h2>
                        <BuyButton/>
                    </div>
                </section>
            </section>
        );
    },
    getInitialState() {
        return {};
    }
});

export default Marty.createContainer(InTheHome, {});



/** WEBPACK FOOTER **
 ** ./app/views/anonymous/views/in-the-home/Handler.js
 **/